import { render, staticRenderFns } from "./TabsNavigation.vue?vue&type=template&id=0957ecd6&"
import script from "./TabsNavigation.vue?vue&type=script&lang=js&"
export * from "./TabsNavigation.vue?vue&type=script&lang=js&"
import style0 from "./TabsNavigation.vue?vue&type=style&index=0&id=0957ecd6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports